import { Create, SimpleForm, TextInput, required, minLength, maxLength } from 'react-admin';

const validateName = [required(), minLength(2), maxLength(100)];

export const GroupCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" validate={validateName} fullWidth />
    </SimpleForm>
  </Create>
);
